//PACKS
import React from "react";
import { useSpring, animated } from "react-spring";

//STYLES
import "../styles/productInfoMobile.scss";

export default function ProductInfoMobile(props) {
  const productInfoPopup = useSpring({
    from: { transform: "translatey(50px)", opacity: 0 },
    to: { transform: "translatey(0)", opacity: 1 },
    delay: 100,
  });
  return (
    
    <div className="productInfoMobileContainer">
      <animated.div style={productInfoPopup}>
        <h2 className="productInfoTitle">{props.product.name}</h2>
        <p className="productInfoParagraph">{props.product.description}</p>
        <br></br>
        {props.product.link ? (
          <a target="_blank" href={props.product.link}>
            See more
          </a>
        ) : (
          <></>
        )}

      </animated.div>
    </div>
 
  );
}
